import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/grin-tongue-squint': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM312 408C312 443.6 282.9 472.5 247.1 472 212 471.5 184 442.2 184 407V364.2L201.7 355.4C216.7 347.9 233.2 357.1 236.6 371.9L239.4 384C241.5 393.2 254.6 393.2 256.7 384L259.5 371.9C262.9 357.1 279.3 347.8 294.4 355.4L312.1 364.2V408zM340.2 433.3C342.4 425.2 344 416.8 344 408V364.5C358.2 352.1 368.4 337 371.3 320 373 310.1 363.6 301.5 353.6 304.7 327.7 313 289.2 317.8 248 317.8S168.4 313 142.4 304.7C132.5 301.6 123 310 124.7 320 127.6 337 137.8 352.1 152 364.5V408C152 416.8 153.6 425.2 155.8 433.3 91.8 399.9 48 333 48 256 48 145.7 137.7 56 248 56S448 145.7 448 256C448 333 404.2 399.9 340.2 433.3zM377.1 152.2C373.3 147.8 366.8 146.7 361.8 149.7L281.8 197.7C278.2 199.9 276 203.8 276 208S278.2 216.1 281.8 218.3L361.8 266.3C367.2 269.5 373.5 268 377.1 263.8 380.9 259.3 380.9 252.8 377.2 248.3L343.6 208 377.2 167.7C381 163.2 380.9 156.6 377.1 152.2zM214.2 197.7L134.2 149.7C129.2 146.7 122.8 147.7 118.9 152.2 115.1 156.7 115.1 163.2 118.8 167.7L152.4 208 118.8 248.3C115 252.8 115.1 259.3 118.9 263.8 122.5 268 128.8 269.5 134.2 266.3L214.2 218.3C217.8 216.1 220 212.2 220 208S217.8 199.9 214.2 197.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/grin-tongue-squint.js
// module id = X2nV
// module chunks = 144